import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://the-hands-off-hosting-system.impultienda.ar/checkout';
const OFFER_ANCHOR = '#offer';
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
  /** 'offer' scrolls to the pricing block, 'checkout' opens the checkout page. */
  target?: 'offer' | 'checkout';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg',
  target = 'offer'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-sm sm:px-9 sm:text-base' : 'px-6 py-3 text-sm';
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`inline-flex items-center justify-center rounded-full bg-brand-gold font-body font-black uppercase tracking-[0.04em] text-brand-deep shadow-lg shadow-[#0d1a30]/25 transition duration-200 hover:-translate-y-0.5 hover:bg-[#dcae3c] hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-gold/50 ${sizing} ${className}`} data-id="element-1" data-mp="10cg5m6qcj54v">
      {label}
    </a>;
}